export var BETTER_THAN_AI_SECT_ID = "better-than-generative-AI";
export var TRANSPARENT_PRICING_SECT_ID = "transparent-pricing";
export var TRIAL_EXPIRATION = "30-day";
